<template>
  <tr>
    <td>
      <template v-if="limit.entity_id">
        {{ localModelValue.name }}
      </template>

      <v-autocomplete
        v-else
        v-model="localModelValue.entity_id"
        :items="entities"
      />
    </td>

    <td>
      <v-text-field
        v-model.number="localModelValue.payout_limits.daily_limit"
        class="mt-0 pt-0"
        type="number"
        min="0"
        hide-details
      />
    </td>
    <td>
      <v-text-field
        v-model.number="localModelValue.payout_limits.weekly_limit"
        class="mt-0 pt-0"
        type="number"
        min="0"
        hide-details
      />
    </td>
    <td>
      <v-text-field
        v-model.number="localModelValue.payout_limits.monthly_limit"
        class="mt-0 pt-0"
        type="number"
        min="0"
        hide-details
      />
    </td>
    <td align="end">
      <v-btn
        icon
        color="primary"
        @click="$emit('save', localModelValue)"
      >
        <v-icon>save</v-icon>
      </v-btn>
      <v-btn
        icon
        color="primary"
        @click="$emit('close')"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    limit: {
      type: Object,
      default: () => ({
        name: '',
        payout_limits: {
          daily_limit: null,
          weekly_limit: null,
          monthly_limit: null,
        },
      })
    },
    entities: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      localModelValue: _.cloneDeep(this.limit)
    }
  }
}
</script>
